import { render, staticRenderFns } from "./tenderList.vue?vue&type=template&id=65f4e768&scoped=true&"
import script from "./tenderList.vue?vue&type=script&lang=js&"
export * from "./tenderList.vue?vue&type=script&lang=js&"
import style0 from "./tenderList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./tenderList.vue?vue&type=style&index=1&id=65f4e768&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f4e768",
  null
  
)

export default component.exports